import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import './App.css';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import VersionDisplay from './components/VersionDisplay';

// Auth Components
import { AuthProvider, useAuth } from './components/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Import AWS configuration
import './aws-config';

function AppContent() {
  const { isLoggedIn, user, logout } = useAuth();
  
  return (
    <div className="App">
      <nav className="main-nav">
        <div className="nav-container">
          <Link to="/" className="nav-logo">Ivyron</Link>
          <div className="nav-links">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/dashboard" className="nav-link">Dashboard</Link>
            {isLoggedIn ? (
              <button onClick={logout} className="nav-link logout-button">Logout</button>
            ) : (
              <Link to="/login" className="nav-link">Login</Link>
            )}
          </div>
        </div>
      </nav>
      
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={isLoggedIn ? <Navigate to="/dashboard" /> : <Login />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </main>
      
      <footer className="main-footer">
        <VersionDisplay />
        <p>&copy; {new Date().getFullYear()} Ivyron Smart Home. All rights reserved.</p>
        {isLoggedIn && user?.attributes?.email && (
          <p className="user-info">Logged in as: {user.attributes.email}</p>
        )}
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;